import React from "react";
import BookShelf from "../BookShelf/BookShelf";
import MyTwitter from "../Twitter/Twitter";
import SearchButton from "../SearchButton/SearchButton";
import { connect, useSelector } from "react-redux";
import * as actions from "../../redux/book/bookActions";
import * as constants from "../../Constants";
import "./MainPage.css";

const MainPage = (props) => {
  const __books = useSelector((state) => state.bookReducer.books);

  props.getInitialBooks();

  return (
    <>
      <div className="list-books">
        <div className="list-books-content">
          <div>
            {constants.SHELVES.map((s) => (
              <BookShelf
                key={s.id}
                shelfname={s.title}
                books={__books.filter((book) => book.shelf === s.id)}
              />
            ))}
          </div>
        </div>
        <SearchButton />
        <MyTwitter />
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    moveBookToShelf: (book) => dispatch(actions.moveBookToShelf(book)),
    setAllShelfs: (books) => dispatch(actions.setAllShelfs(books)),
    getInitialBooks: () => dispatch(actions.getInitialBooks()),
  };
};

export default connect(null, mapDispatchToProps)(MainPage);
